import type { ReactNode } from "preact/compat";
import { createContext, useContext } from "preact/compat";
import type { RunProcess } from "~/utils/create-process-runner.ts";

const Context = createContext<RunProcess | undefined>(undefined);

type HeavyProcessRunnerProviderProps = {
	readonly runProcess: RunProcess;
	readonly children: ReactNode;
};

function HeavyProcessRunnerProvider({
	runProcess,
	children,
}: HeavyProcessRunnerProviderProps) {
	return <Context.Provider value={runProcess}>{children}</Context.Provider>;
}

function useHeavyProcessRunner(): RunProcess {
	const runner = useContext(Context);
	if (runner === undefined) {
		throw new Error("No heavy process context");
	}
	return runner;
}

export { useHeavyProcessRunner, HeavyProcessRunnerProvider, Context };
